/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-table-cell-background: Specifies the background color of the component.
*/
:host {
  --calcite-internal-table-cell-background: var(--calcite-table-cell-background, transparent);
  display: contents;
}

:host([alignment=center]) td:not(.selection-cell):not(.number-cell) {
  text-align: center;
}

:host([alignment=end]) td:not(.selection-cell):not(.number-cell) {
  text-align: end;
}

.assistive-text {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

td {
  white-space: normal;
  text-align: start;
  vertical-align: middle;
  color: var(--calcite-color-text-1);
  background: var(--calcite-internal-table-cell-background);
  font-size: var(--calcite-internal-table-cell-font-size);
  border-inline-end: 1px solid var(--calcite-color-border-3);
  padding: var(--calcite-internal-table-cell-padding);
}
td:not(.static-cell) {
  outline-color: transparent;
}
td:not(.static-cell):focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

td.start.content-cell {
  vertical-align: top;
}

td.end.content-cell {
  vertical-align: bottom;
}

td.last-cell {
  border-inline-end: 0;
}

.number-cell {
  background-color: var(--calcite-color-foreground-2);
}

.footer-cell {
  background-color: var(--calcite-color-background);
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
  border-block-start: 1px solid var(--calcite-color-border-3);
}

.number-cell,
.selection-cell {
  text-align: center;
  border-inline-end: 1px solid var(--calcite-color-border-3);
  inline-size: 2rem;
  min-inline-size: 2rem;
}

.selection-cell {
  color: var(--calcite-color-text-3);
  inset-inline-start: 2rem;
}
.selection-cell:not(.footer-cell) {
  cursor: pointer;
}

.selected-cell:not(.number-cell):not(.footer-cell) {
  --calcite-internal-table-cell-background: var(--calcite-color-foreground-current);
}

.selection-cell.selected-cell {
  box-shadow: inset 0.25rem 0 0 0 var(--calcite-color-brand);
  color: var(--calcite-color-brand);
}
.selection-cell.selected-cell calcite-icon {
  color: var(--calcite-color-brand);
}

.calcite--rtl.selection-cell.selected-cell {
  box-shadow: inset -0.25rem 0 0 0 var(--calcite-color-brand);
}

.selection-cell {
  vertical-align: middle;
}
.selection-cell ::slotted(calcite-icon) {
  pointer-events: none;
  margin-block-start: 0.25rem;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}